import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) nav("/");
    else setErr(r.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <div className="text-xs font-mono uppercase tracking-widest text-red-500 mb-1">Debut</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase">Create Account</h1>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div>
          <Label>Ring Name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)}
            data-testid="register-name" placeholder="Optional" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password" className="bg-slate-950 border-slate-700 h-11" />
        </div>
        {err && <div className="text-red-400 text-sm" data-testid="register-error">{err}</div>}
        <Button type="submit" disabled={busy} data-testid="register-submit"
          className="w-full h-11 bg-red-600 hover:bg-red-500 text-white font-bold uppercase tracking-wide">
          {busy ? "Debuting…" : "Make Your Debut"}
        </Button>
      </form>
      <p className="mt-4 text-sm text-slate-400">
        Already have an account? <Link to="/login" className="text-red-500 font-semibold" data-testid="link-login">Sign in</Link>
      </p>
    </div>
  );
}
